<template>
  <div class="page-content-wrapper">
    <div class="content">
      <div class="container-fluid container-fixed-lg">
        <div class="row p-3">
          <div class="col-lg-12">
            <h2 class="text-dag">{{ $t('menu_contact') }}</h2>
          </div>
        </div>

        <div class="row">
          <div class="col-lg-6 m-b-10">
            <div class="card no-border widget-loader-circle no-padding rounded">
              <div class="card-body p-t-25 p-b-30">
                <form>
                  <div class="form-group contact">
                    <label for="email">
                      <p class="adviestitle">{{ $t('profile_email') }}</p>
                    </label>
                    <b-form-input id="email"
                                  type="email"
                                  class="form-control form-control-lg"
                                  v-model="email"
                                  :readonly="submitted"
                    >
                    </b-form-input>
                  </div>
                  <div class="form-group contact">
                    <label for="subject">
                      <p class="adviestitle">{{ $t('contact_subject') }}</p>
                    </label>
                    <b-form-input id="subject"
                                  type="text"
                                  class="form-control form-control-lg"
                                  v-model="subject"
                                  :readonly="submitted"
                    >
                    </b-form-input>
                  </div>
                  <div class="form-group contact">
                    <label for="message">
                      <p class="adviestitle">{{ $t('contact_message') }}</p>
                    </label>
                    <b-form-textarea id="message"
                                     class="form-control form-control-lg"
                                     rows="6"
                                     v-model="message"
                                     :readonly="submitted"
                    >
                    </b-form-textarea>
                  </div>
                </form>
                <button v-if="!submitted" class="advicebutton text-white confirm"
                        @click="submitContact">
                  {{ $t('contact_submit') }}
                </button>
                <span v-else>{{$t('contact_sent')}}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  data () {
    return {
      email: '',
      subject: '',
      message: '',
      submitted: false
    }
  },
  computed: {
  },
  methods: {
    ...mapActions([
      'contactSubmit',
    ]),
    submitContact () {
      this.contactSubmit(
              {
                'EmailAddress': this.email,
                'Subject':      this.subject,
                'Message':      this.message,
              }
      ).then( r => {
        this.submitted = true
      })
    }
  },
  created() {

  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/info/Contact.vue